import { SocialConnectionsResponse } from '../api';

export const haveCustomSocialConnect = (
  currentSocials: SocialConnectionsResponse | null
): boolean => {
  if (!currentSocials) {
    return false;
  }

  return currentSocials.some((social) => social.is_custom);
};
